import { render } from "./DateField.vue?vue&type=template&id=2fd6db8c"
import script from "./DateField.vue?vue&type=script&lang=js"
export * from "./DateField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DateField.vue"]])

export default __exports__